import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, PenLine } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";

const WA_NUMBER = "6287881161127";

export default function GetStartedCTA() {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast.error(t.cta.error);
      return;
    }
    const msg =
      lang === "id"
        ? `Halo MEMOIRE! Saya tertarik untuk membuat event page.%0AEmail: ${email}`
        : `Hello MEMOIRE! I'd like to create an event page.%0AEmail: ${email}`;
    window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank", "noopener");
    toast.success(t.cta.success);
    setEmail("");
  };

  return (
    <section id="reach" data-testid="cta-section" className="relative overflow-hidden bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-['Outfit'] text-4xl font-light leading-tight tracking-tight text-neutral-950 sm:text-5xl lg:text-6xl"
        >
          Ready to Preserve <br />
          <span className="italic font-['Playfair_Display']">Every Perspective?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mx-auto mt-5 max-w-md text-base leading-relaxed text-neutral-600"
        >
          {t.cta.body}
        </motion.p>

        <motion.form
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          onSubmit={submit}
          className="mx-auto mt-12 flex max-w-xl items-center gap-2 rounded-full border border-neutral-300 bg-white p-1.5 pl-6 shadow-[0_1px_2px_rgba(0,0,0,0.04)] focus-within:border-neutral-900 focus-within:shadow-md transition-all"
        >
          <PenLine className="h-4 w-4 text-neutral-400" strokeWidth={1.5} />
          <input
            data-testid="inquiry-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t.cta.placeholder}
            className="flex-1 bg-transparent px-2 py-2 text-sm text-neutral-900 outline-none placeholder:text-neutral-400"
          />
          <button
            data-testid="inquiry-submit-btn"
            type="submit"
            className="group inline-flex items-center gap-2 rounded-full bg-neutral-950 px-5 py-2.5 text-sm text-white transition-all hover:bg-neutral-800"
          >
            {t.cta.button}
            <ArrowUpRight
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              strokeWidth={1.75}
            />
          </button>
        </motion.form>

        <p className="mt-4 text-[11px] uppercase tracking-[0.2em] text-neutral-400">
          No spam. Just memories.
        </p>
      </div>
    </section>
  );
}
